export const PRICE_L_PEAK_SEASON_WEEK = 8400
export const PRICE_L_PEAK_SEASON_SUN_THUR = 4800
export const PRICE_L_PEAK_SEASON_THUR_SUN = 4800
export const PRICE_L_PEAK_SEASON_DAY = 1200

export const PRICE_L_LOW_SEASON_WEEK = 6000
export const PRICE_L_LOW_SEASON_SUN_THUR = 3600
export const PRICE_L_LOW_SEASON_THUR_SUN = 3600
export const PRICE_L_LOW_SEASON_DAY = 860


export const PRICE_S_PEAK_SEASON_WEEK = 6000
export const PRICE_S_PEAK_SEASON_SUN_THUR = 3000
export const PRICE_S_PEAK_SEASON_THUR_SUN = 3600
export const PRICE_S_PEAK_SEASON_DAY = 900

export const PRICE_S_LOW_SEASON_WEEK = 3600
export const PRICE_S_LOW_SEASON_SUN_THUR = 2400
export const PRICE_S_LOW_SEASON_THUR_SUN = 3000
export const PRICE_S_LOW_SEASON_DAY = 520


export const PRICE_F_PEAK_SEASON_WEEK = 4000
export const PRICE_F_PEAK_SEASON_DAY = 600

export const PRICE_F_LOW_SEASON_WEEK = 2500
export const PRICE_F_LOW_SEASON_DAY = 350

export const PEAK_SEASON_WEEKS = [1,7,8,9,10,15,16,17,18,52]